import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const MapPage = lazy(() => import("@/components/MapPage"));

function MapFallback() {
  return (
    <div className="flex h-[calc(100vh-7rem)] w-full items-center justify-center bg-black">
      <p className="animate-pulse text-sm text-white/40">Karte wird geladen…</p>
    </div>
  );
}

function MapRoute() {
  if (typeof window === "undefined") {
    return null;
  }

  return (
    <Suspense fallback={<MapFallback />}>
      <MapPage />
    </Suspense>
  );
}

export const Route = createFileRoute("/map")({
  head: () => ({
    meta: [
      { title: "Map · Pulse" },
      { name: "description", content: "Live venues near you tonight." },
    ],
  }),
  component: MapRoute,
});
